import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS,  } from "./api-base"
import { getESGReqHeader } from "./tool-service";

export const queryTsmpSetting = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010301'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010301")}`, method: 'post', data: ReqBody })
}

export const updateTsmpSetting = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010302'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010302")}`, method: 'post', data: ReqBody })
}
